import {
	EventBus
} from '@/utils/eventBus';

export default {
	data() {
		return {
			tooltipVisible: false,
			currentElement: null,
			mouseX: 0,
			mouseY: 0,
			isLocked: false,
			hideTimeout: null,
			courseid: 0,
			page: 0,
			id: 0
		};
	},
	created() {
		EventBus.$on('tooltip:show', this.showTooltip);
		EventBus.$on('tooltip:hide', this.hideTooltip);
	},
	beforeDestroy() {
		EventBus.$off('tooltip:show', this.showTooltip);
		EventBus.$off('tooltip:hide', this.hideTooltip);
	},
	methods: {
		showTooltip({
			mouseX,
			mouseY,
			element
		}) {
			if (!this.isLocked) {
				this.tooltipVisible = true;
				const rect = element.getBoundingClientRect();
				// this.mouseX = mouseX;
				// this.mouseY = mouseY;
				this.mouseX = rect.left + window.pageXOffset;
				this.mouseY = rect.bottom + window.pageYOffset;
				this.currentElement = element;
				if (element.dataset.courseid != 0) {
					this.courseid = element.dataset.courseid
					this.page = element.dataset.page
					this.id = element.dataset.id
				} else {
					this.courseid = 0;
					this.page = 0;
					this.id = element.dataset.id
				}
			}
		},
		hideTooltip() {
			if (!this.isLocked) {
				clearTimeout(this.hideTimeout);
				this.hideTimeout = setTimeout(() => {
					this.tooltipVisible = false;
				}, 200);
			}
		},
		lockTooltip() {
			this.isLocked = true;
			clearTimeout(this.hideTimeout);
		},
		releaseTooltip() {
			this.isLocked = false;
			this.hideTooltip();
		},
		handleIconClick(iconType) {
			if (this.currentElement) {
				const data = this.currentElement.dataset;
				console.log('Icon clicked:', iconType, 'Data:', data);
				if (iconType === 'book') {
					this.openBook(data)
				} else if (iconType == 'favorite') {
					this.openChat(data.content)
				}
			}
		}
	}
};